

import React, { useEffect } from 'react';
import './VisionMission.css';

const VisionMission = () => {

  useEffect(() => {
    const sections = document.querySelectorAll('.vm-card');

    const revealOnScroll = () => {
      const triggerBottom = window.innerHeight * 0.85;

      sections.forEach(section => {
        const boxTop = section.getBoundingClientRect().top;

        if (boxTop < triggerBottom) {
          section.classList.add('show');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  return (
    <div className="vm-container">
      <h2 className="vm-title">Our Vision and Mission</h2>
      <p className="vm-subtitle">Building a healthier tomorrow through quality pharmacy education</p>

      {/* Vision */}
      <div className="vm-card">
        <h3><i className="fa-solid fa-eye"></i> Vision</h3>
        <p>
          To develop globally competent pharmacists equipped with cognitive, technical, and ethical skills,
          ready to advance the healthcare and pharmaceutical industries.
        </p>
      </div>

      {/* Mission */}
      <div className="vm-card">
        <h3><i className="fa-solid fa-bullseye"></i> Mission</h3>
        <ul>
          <li>To establish a world-class learning environment with modern infrastructure.</li>
          <li>To deliver student-centric education promoting innovation & entrepreneurship.</li>
          <li>To strengthen the industry–academia relationship for skill development.</li>
          <li>To instill social responsibility, compassion & lifelong learning.</li>
        </ul>
      </div>

      {/* Values */}
      <div className="vm-card">
        <h3><i className="fa-solid fa-hand-holding-heart"></i> Values</h3>
        <ul>
          <li>Commitment to excellence in education & research.</li>
          <li>Integrity, ethics & professionalism.</li>
          <li>Teamwork, respect & inclusiveness.</li>
          <li>Reliable, disciplined & compassionate service mindset.</li>
        </ul>
      </div>

      {/* Motto & Tagline */}
      <div className="vm-card">
        <h3><i className="fa-solid fa-quote-left"></i> Motto</h3>
        <p className="motto">
          हस्ते विभ्रद्रेषजा  
          <br />
          “A pharmacist has the divine ability to create life-healing medicines.”
        </p>

        <h3><i className="fa-solid fa-lightbulb"></i> Tagline</h3>
        <p className="tagline">"Developing Good Minds"</p>
      </div>
    </div>
  );
};

export default VisionMission;
